import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  image: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flex: '1 0 20%',
    maxWidth: '20%',
    alignSelf: 'center',
    justifySelf: 'center',

    maxWidthMobile: {
      flex: '1 0 50%',
      maxWidth: '50%',
    },
  },

  image: {
    width: 'auto',
    height: '100%',
    transform: 'translateX(-50%)',
    left: '50%',
  },
});

export default styles;
